import { render } from "./CreateOrderPage.vue?vue&type=template&id=4890c2d7"
import script from "./CreateOrderPage.vue?vue&type=script&lang=js"
export * from "./CreateOrderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__